/* unplugin-vue-components disabled */import script from "./ImageMj.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageMj.vue?vue&type=script&setup=true&lang=js"

import "./ImageMj.vue?vue&type=style&index=0&id=2448961d&lang=stylus"

const __exports__ = script;

export default __exports__